export enum Logic {
  AND = 'and',
  OR = 'or',
}

export enum Operator {
  STARTSWITH = 'startswith',
  ENDSWITH = 'endswith',
  EQUAL = 'eq', // equal to
  NOTEQUAL = 'neq', // not equal to
  ISNULL = 'isnull', // is equal to null
  ISNOTNULL = 'isnotnull', // is not equal to null
  LT = 'lt', // less than
  LTE = 'lte', // less than or equal to
  GT = 'gt', // greater than
  GTE = 'gte', // greater than or equal to
  CONTAINS = 'contains',
  DOESNOTCONTAIN = 'doesnotcontain',
  ISEMPTY = 'isempty',
  ISNOTEMPTY = 'isnotempty',
  IN = 'in', // value is inside
  INCLUDE = 'include', //only for filter in Static
}

export enum AFLogic {
  AND = 'AND',
  OR = 'OR',
}

export enum AFOperator {
  EQUAL = '=',
  NOT_EQUAL = '!=',
  GT = '>',
  GTE = '>=',
  LT = '<',
  LTE = '<=',
  IN = 'IN',
  NOT_IN = 'NOT IN',
  LIKE = 'LIKE',
  NOT_LIKE = 'NOT LIKE',
  EMPTY_OR_NULL = 'EMPTY OR NULL',
  NOT_EMPTY_AND_NOT_NULL = 'NOT EMPTY AND NOT NULL',
}

export interface IFilter {
  operator: Operator | IFilterOperator
  field: string
  value: number | string | null | string[]
}

export interface IDataProviderFilter {
  logic: Logic
  filters: Array<IFilter | IDataProviderFilter>
}

export type IFilterOperator =
  | 'startswith'
  | 'endswith'
  | 'eq' // equal to
  | 'neq' // not equal to
  | 'isnull' // is equal to null
  | 'isnotnull' // is not equal to null
  | 'lt' // less than
  | 'lte' // less than or equal to
  | 'gt' // greater than
  | 'gte' // greater than or equal to
  | 'contains'
  | 'doesnotcontain'
  | 'isempty'
  | 'isnotempty'

export type Direction = 'asc' | 'desc'

export interface IDataProviderSort {
  field: string
  dir: Direction
}

export interface IDataSource {
  formId: string
  code: string
}
